import { createAction } from '@reduxjs/toolkit';
import { PermissionsResponse } from 'features/admin-permissions/api/types';

export const adminPermissionsActions = {
  clearState: createAction('[admin_permissions]CLEAR_ADMIN_PERMISSIONS_STATE'),
  getPermissionsRequest: createAction<{ partnerName?: string }>(
    '[admin_permissions]GET_PERMISSIONS_REQUEST'
  ),
  getPermissionsSuccess: createAction<PermissionsResponse>(
    '[admin_permissions]GET_PERMISSIONS_SUCCESS'
  ),
  getPermissionsFailure: createAction<string[]>(
    '[admin_permissions]GET_PERMISSIONS_FAILURE'
  ),
};
